var _path, _path2, _path3, _path4, _circle, _circle2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickupsTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3H13C14.1046 3 15 3.89543 15 5V19",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3H1",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7L1 7",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11L1 11",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 21 17)",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 8 17)",
    stroke: "black",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0148 9.21913C18.7776 8.92261 18.4185 8.75 18.0388 8.75H15C14.5858 8.75 14.25 8.41421 14.25 8C14.25 7.58579 14.5858 7.25 15 7.25H18.0388C18.8742 7.25 19.6643 7.62975 20.1861 8.28209L23.1474 11.9837C23.5375 12.4713 23.75 13.0771 23.75 13.7016V17C23.75 18.5188 22.5188 19.75 21 19.75H20.8546C20.9484 19.5184 21 19.2652 21 19C21 18.7348 20.9484 18.4816 20.8546 18.25H21C21.6904 18.25 22.25 17.6904 22.25 17V13.7016C22.25 13.4177 22.1534 13.1423 21.9761 12.9207L19.0148 9.21913ZM17.1454 18.25C17.0516 18.4816 17 18.7348 17 19C17 19.2652 17.0516 19.5184 17.1454 19.75H7.85462C7.94837 19.5184 8 19.2652 8 19C8 18.7348 7.94837 18.4816 7.85462 18.25H17.1454ZM4.14538 18.25C4.05163 18.4816 4 18.7348 4 19C4 19.2652 4.05163 19.5184 4.14538 19.75H3C1.48122 19.75 0.25 18.5188 0.25 17V15C0.25 14.5858 0.585787 14.25 1 14.25C1.41421 14.25 1.75 14.5858 1.75 15V17C1.75 17.6904 2.30964 18.25 3 18.25H4.14538Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupsTruck);
export default __webpack_public_path__ + "static/media/pickups-truck.841286810b1ccfcc2deac2b9c1d1ca16.svg";
export { ForwardRef as ReactComponent };